'use client'

import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { AppHeader } from '@/routes/_app/-components/AppHeader'
import { UploadTray } from '@/components/shared/UploadTray'
import { useAuth } from '@/contexts/AuthContext'
import { captureRedirectTarget } from '@/lib/auth-redirect'

export const Route = createFileRoute('/_app')({
  beforeLoad: ({ context }) => {
    const { isAuthenticated, isLoading } = context.auth

    // Wait for Keycloak to finish initializing before redirecting
    if (!isAuthenticated && !isLoading) {
      throw redirect({
        to: '/login',
        search: {
          redirect: captureRedirectTarget(),
        },
      })
    }
  },
  component: AppLayout,
})

function AppLayout() {
  const { isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4">
          <div className="h-12 w-12 animate-spin rounded-full border-4 border-primary border-t-transparent" />
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="flex min-h-screen flex-col">
      {/* Animated Header */}
      <AppHeader />

      {/* Main Content */}
      <main className="flex-1">
        <div className="mx-auto max-w-[1800px] px-4 py-4 sm:px-6">
          <Outlet />
        </div>
      </main>

      {/* Client-file upload tray (sc-1352): mounted once at the shell so
          in-flight uploads survive navigating away from the client page. */}
      <UploadTray />
    </div>
  )
}
